import React from "react";
import PropTypes from "prop-types";
import { syncTerminalEmployee } from "redux/organization/employeeSlice";
import SyncEmployeeConfirm from "./SyncEmployeeConfirm";

const SyncTerminalEmployeeConfirm = ({ showModal, setshowModal }) => (
  <SyncEmployeeConfirm
    showModal={showModal}
    setshowModal={setshowModal}
    title="Sync terminal employees"
    message="Are you sure to sync terminal employees from iHRM now?"
    action={syncTerminalEmployee}
  />
);

SyncTerminalEmployeeConfirm.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
};

export default SyncTerminalEmployeeConfirm;
